/**
 * @generated SignedSource<<aaff9cda635c852393fecce9b8eebb8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type WACategoryTodoCategoriesSelectCategoryQuery$variables = Record<PropertyKey, never>;
export type WACategoryTodoCategoriesSelectCategoryQuery$data = {
  readonly store: {
    readonly todoCategories: ReadonlyArray<{
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly title: string;
    }>;
  };
};
export type WACategoryTodoCategoriesSelectCategoryQuery = {
  response: WACategoryTodoCategoriesSelectCategoryQuery$data;
  variables: WACategoryTodoCategoriesSelectCategoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "includeIntegrations",
      "value": false
    }
  ],
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "todoCategories",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": "todoCategories(includeIntegrations:false)"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WACategoryTodoCategoriesSelectCategoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WACategoryTodoCategoriesSelectCategoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c37665e0236f905c86c0e547018db35e",
    "id": null,
    "metadata": {},
    "name": "WACategoryTodoCategoriesSelectCategoryQuery",
    "operationKind": "query",
    "text": "query WACategoryTodoCategoriesSelectCategoryQuery {\n  store {\n    todoCategories(includeIntegrations: false) {\n      id\n      icon\n      title\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "155f448bb18efbbd170c3ad2c026a685";

export default node;
